import React from 'react';
import {
  Typography,
} from '@one-thd/sui-atomic-components';

import {
  string, number, oneOfType,
  bool
} from 'prop-types';

export const CabinetInfoSection = ({
  height,
  width,
  depth,
  unit,
  isDesktop
}) => {

  function measurementWithLabel(measurement) {
    return measurement ? `${measurement} ${unit}` : '';
  }

  return (
    <div
      className="section cabinet-info-section"
    >
      <div className="sui-flex sui-gap-x-2 md:sui-gap-x-6">
        <Typography variant="body-xs" color="primary" weight="bold">
          Total Cabinet Dimensions:
        </Typography>
        <div className="sui-flex sui-gap-x-2 md:sui-gap-x-6">
          <Typography variant="body-xs" color="primary">
            {isDesktop ? 'Width' : 'W'}: <b className="sui-whitespace-nowrap">{measurementWithLabel(width)}</b>
          </Typography>
          <Typography variant="body-xs" color="primary">
            {isDesktop ? 'Height' : 'H'}: <b className="sui-whitespace-nowrap">{measurementWithLabel(height)}</b>
          </Typography>
          <Typography variant="body-xs" color="primary">
            {isDesktop ? 'Depth' : 'D'}: <b className="sui-whitespace-nowrap">{measurementWithLabel(depth)}</b>
          </Typography>
        </div>
      </div>
    </div>
  );
};

CabinetInfoSection.propTypes = {
  height: oneOfType([string, number]),
  width: oneOfType([string, number]),
  depth: oneOfType([string, number]),
  unit: string,
  isDesktop: bool
};

CabinetInfoSection.defaultProps = {
  height: '',
  width: '',
  depth: '',
  unit: 'in',
  isDesktop: true
};
